<template >

 <v-dialog
    transition="dialog-bottom-transition"
    max-width="100%"
    v-model="dialogshow"
    persistent
    >
                            
    <v-card style="background-color:#000C17 !important">
          <v-card-actions class="justify-end">
                          <v-btn
                               text
                                  @click="(dialogshow = false), pauseAudioPro()"
                              >
                              <span class="white--text"> Close </span>
                            </v-btn>
                          </v-card-actions>
        <div class="text-h5 text-center white--text pa-10" v-if="attendance == 'absent' ? true : false"> Data Successfully Saved! </div>
        <div v-else>
        <v-card-text>
          
        <v-layout row justify-center>

            <v-flex lg11 xs12 class="text-lg-h5 text-body-1 px-lg-0 px-5 mt-lg-0 mt-10">

                <span class="white--text monsterrat text-lg-h5 font-24"> {{evalData[0].studName  }} Class Evaluation </span>
                <br>
                  <span  class="white--text monsterrat text-lg-body-2 font-14"> {{classDT}} {{StudentData.time}} </span>


            </v-flex>

            <v-flex lg11 class="mt-lg-0 mt-14 px-lg-0 px-4 pb-lg-0 pb-8 mt-md-n10">

                 <v-card class="rounded-lg px-lg-16 py-lg-10 mt-lg-3 mt-n11 px-10 py-10 elevation-0  card-bg white--text" >

                              <v-layout row>

                                  <v-flex lg12 xs12 class="mt-5">

                                      <div>

                                        <span class="montserrat font-18 font-weight-bold"> Lesson </span>
                                        <div class="montserrat font-18 fw-light mt-1">
                                            {{ evalData[0].topicDiscuss}} -  Page {{evalData[0].pageNum}}
                                        </div>

                                    </div>
                                     

                                  </v-flex>
                                  

                                  <v-flex lg12 class="mt-lg-5 mt-6">
                                     

                                    <div>

                                        <span class="montserrat font-18 font-weight-bold"> Sentences </span>

                                    </div>

                                    <div class="montserrat font-18 fw-light mt-1">
                                        <span class="font-nothigh text-lg-body-1 font-14">{{evalData[0].wrongOne}}</span>
                                        <br />
                                        <div class="mt-lg-1 mt-1 fw-semibold"> <span class="font-11 fw-semibold white--text better mr-3 ml-0"> 추천 </span> <span class="correct-sentence text-lg-body-1 font-14"> {{evalData[0].correctOne}} </span> </div>
                                    </div>

                                     <div class="montserrat font-18 fw-light mt-1">
                                        <span class="font-nothigh text-lg-body-1 font-14">{{evalData[0].wrongTwo}}</span>
                                        <br/>
                                       <div class="mt-lg-1 mt-1 fw-semibold"> <span class="font-11 fw-semibold white--text better mr-3 ml-0"> 추천 </span> <span class="correct-sentence text-lg-body-1 font-14"> {{evalData[0].correctTwo}} </span> </div>
                                    </div>

                                     <div class="montserrat font-18 fw-light mt-1">
                                        <span class="font-nothigh text-lg-body-1 font-14 ">{{evalData[0].wrongThree}}</span>
                                        <br/>
                                       <div class="mt-lg-1 mt-1 fw-semibold"> <span class="font-11 fw-semibold white--text better mr-3 ml-0"> 추천 </span> <span class="correct-sentence text-lg-body-1 font-14"> {{evalData[0].correctThree}} </span> </div>
                                    </div>
                                     <div class="montserrat font-18 fw-light mt-1">
                                        <span class="font-nothigh text-lg-body-1 font-14 ">{{evalData[0].wrongFour}}</span>
                                        <br/>
                                       <div class="mt-lg-1 mt-1 fw-semibold"> <span class="font-11 fw-semibold white--text better mr-3 ml-0"> 추천 </span> <span class="correct-sentence text-lg-body-1 font-14"> {{evalData[0].correctFour}} </span> </div>
                                    </div>



                                 </v-flex>

                                 <v-flex lg12 class="mt-lg-5 mt-6">

                                        <div>
                                           
                                        <span class="montserrat font-18 font-weight-bold"> Words to be Careful With </span>

                                        </div>

                                         <v-layout row class="mt-lg-2 mt-3 px-lg-3 px-5">
                                             <v-flex lg12 xs12 md12>
                                                <v-card class="justify-start align-start white--text d-flex mb-10 monsterrat" color="transparent"  flat style="width:200px">
                                                    <v-flex lg12> 
                                                        <div class="montserrat font-18 fw-medium mt-1">
                                                            <wordAudios v-if="audioVal1" number-seq='1.' :word-audio="evalData[0].wordOne" :url="audioVal1" :trans-one="trans1" :texttospeech="texttospeech1" playerid="audio-player" class="ml-lg-0"/>
                                                        </div>
                                                    </v-flex>
                                                </v-card>
                                             </v-flex>
                                             <v-flex lg12 xs12 md12 class="mt-lg-n6 mt-n6">
                                                <v-card class="justify-start align-start white--text d-flex mb-10 monsterrat" color="transparent"  flat style="width:200px">
                                                    <v-flex lg12> 
                                                        <div class="montserrat font-18 fw-medium mt-1">
                                                      <wordAudios v-if="audioVal2"  number-seq='2.' :word-audio="evalData[0].wordTwo" :url="audioVal2" :trans-one="trans2" :texttospeech="texttospeech2" playerid="audio-player" class="ml-lg-0"/>
                                                        </div>
                                                    </v-flex>
                                                </v-card>
                                             </v-flex>
                                             <v-flex lg12 xs12 md12 class="mt-lg-n6 mt-n6">
                                                <v-card class="justify-start align-start white--text d-flex mb-10 monsterrat" color="transparent"  flat style="width:200px">
                                                    <v-flex lg12> 
                                                        <div class="montserrat font-18 fw-medium mt-1">
                                                      <wordAudios v-if="audioVal3"  number-seq='3.' :word-audio="evalData[0].wordThree" :url="audioVal3" :trans-one="trans3" :texttospeech="texttospeech3" playerid="audio-player" class="ml-lg-0"/>
                                                        </div>
                                                    </v-flex>
                                                </v-card>
                                             </v-flex>
                                             
                                         </v-layout>

                                 </v-flex>

                                  <v-flex lg12 md12 xs12 class="mt-lg-0 monsterrat">

                                        <div>

                                        <span class="text-lg-h6 font-18 monsterrat"> Pronunciation Tip </span>

                                        </div>

                                         <v-layout row  class="mt-2 mt-lg-5 px-lg-1 px-2 montserrat">
                                             <v-flex lg12 md12 xs12 class="font-18 font-weight-bold mt-1">
                                                <span> {{ pronuciation[evalData[0].tipScore-1]}} </span>
                                             </v-flex>
                                             <v-flex lg12 md12 xs12>
                                                <v-card class="justify-start align-start white--text d-flex mb-10 px-lg-0" color="transparent"  flat>
                                                    <v-flex lg12 xs12> 
                                                        <div class="fw-light font-14">
                                                            
                                                            <ProAudio v-if="evalData[0].tipScore" :word-audio="sentence[evalData[0].tipScore-1]" :url="evalData[0].tipScore" playerid="audio-player" class="ml-lg-0"/>
                                                        </div>
                                                    </v-flex>
                                                </v-card>
                                             </v-flex>
                                             
                                         </v-layout>

                                 </v-flex>


                              </v-layout> 


                </v-card>

         </v-flex>
          <v-flex lg12 xs12 class="text-center mt-lg-10 pb-2 pb-lg-0">
                                    <v-img src="@/assets/images/LevelTest/reports/mega_blue.png" aspect-ratio="1" max-height="100" contain></v-img>
                                   

        </v-flex>

        

        </v-layout>
        </v-card-text>
        </div>
  </v-card>
 </v-dialog>

</template>
    
<style scoped>
html {
  margin: 10px;
}
.correct-sentence {
  color: rgb(139, 220, 255);
  margin-left: 6px;
}
.better {
  background-color: #0377bc;
  padding: 5px;
  border-radius: 5px;
  text-align: center;
  margin: auto;
}
.font-nothigh {
  color: rgb(205, 205, 205);
}
.hidetext {
  color: rgb(0, 12, 23) !important;
}
.class-audio-btn {
  background-color: rgb(0, 12, 23) !important;
  width: 50% !important;
}

.montserrat {
  font-family: "Montserrat", serif !important;
}

.card-bg {
  background-color: rgb(16, 25, 43);
  background-image: url("../../../assets/images/RegularClass/mega-man-white2.png");
  background-repeat: no-repeat;
  background-position: 95% 95%;
  background-size: 20%;
}
.card-height {
  height: 621px;
}
.progress-color1 {
  color: #02a9f4 !important;
}
.logo-mega {
  max-height: 50px !important;
}
.logo-mega2 {
  max-height: 40px !important;
}
.logo-mega3 {
  max-height: 35px !important;
}
.mt-17 {
  margin-top: 100px;
}
.mt-18 {
  margin-top: 150px;
}
#journal-scroll::-webkit-scrollbar {
  width: 4px;
  cursor: pointer;
}
#journal-scroll::-webkit-scrollbar-track {
  background-color: rgba(229, 231, 235, var(--bg-opacity));
  cursor: pointer;
}
#journal-scroll::-webkit-scrollbar-thumb {
  cursor: pointer;
  background-color: #a0aec0;
}
.cd-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #f7fafc;
}

#progressButtonTimer,
#progressButtonVolume {
  margin-top: -9px;
  right: -8px;
}

.fw-light {
  font-weight: 300;
}
.fw-medium {
  font-weight: 500;
}
.fw-semibold {
  font-weight: 600;
}
.font-10 {
  font-size: 10px !important;
}
.font-11 {
  font-size: 11px !important;
}
.font-12 {
  font-size: 12px !important;
}
.font-18 {
  font-size: 18px !important;
}
.font-24 {
  font-size: 24px !important;
}

@media screen and (max-width: 900px) {
  .better {
    background-color: #0377bc;
    padding: 3px;
    border-radius: 2px;
    text-align: center;
    margin: auto;
    font-size: 10px;
  }
  #evaluation {
    background: #000c17 !important;
    padding: 20px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .mt-17 {
    margin-top: 0px;
  }
  .mt-18 {
    margin-top: 0px;
  }

  .font-13 {
    font-size: 13px !important;
  }
  .font-14 {
    font-size: 14px !important;
  }

  .font-15 {
    font-size: 15px !important;
  }
  .font-20 {
    font-size: 20px !important;
  }

  .font-28 {
    font-size: 28px !important;
  }
  .card-bg {
    background-color: rgb(16, 25, 43);
    background-image: url("../../../assets/images/RegularClass/mega-man-white2.png");
    background-repeat: no-repeat;
    background-position: 100% 98%;
    background-size: 50%;
  }
  .card-height {
    height: 621px;
  }
  .card-height2 {
    height: 751px;
  }
  .logo-mega {
    max-height: 40px !important;
  }
  .logo-mega2 {
    max-height: 25px !important;
  }
  .logo-mega3 {
    max-height: 25px !important;
  }

  .class-audio-btn {
    width: 100% !important;
  }
}
</style>
<style scoped>

@import '../../../../src/assets/css/RegularClass/audioplayer.css';

</style>
<script>
// import PieChartNew from '@/components/PieChartNew'
// import BarChartNew from '@/components/BarChartNew'
// import AudioOne from '@/components/audioOne'
// import AudioTwo from '@/components/RegularClass/ClassRecordingAudio'
import wordAudios from '@/components/RegularClass/audioOne'
import ProAudio from '@/components/RegularClass/audioPron'
import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
    name: 'evaluationformnew',
    props:['studName','topicDiscuss','pageNum','submitStat','wrongOne','wrongTwo','wrongThree','wrongFour','correctOne','correctTwo','correctThree','correctFour','wordOne','wordTwo','wordThree','tipScore','commentText'],
    components:{
    //  PieChartNew,
    //  BarChartNew,
    //  AudioOne,
    // AudioTwo,
    wordAudios,
    ProAudio,
    },
    data:()=>{
        return{
            next:1,
            prev:2,
            classDT:'',
            evalData:[],
            dialogshow:false,
            StudentData:null,
            StudentInfo:null,
            StudentRecordingData:null,
            StudentName:null,
            StudentRecordData:null,
            audioVal1:null,
            audioVal2:null,
            audioVal3:null,
            wordOneVal:'',
            wordTwoVal:'',
            wordThreeVal:'',
            trans1:"",
            trans2:"",
            trans3:"",
            getdif1:"",
            getdif2:"",
            getdif3:"",
            windowwidth: screen.width,
            pronuciation:[
                '/i/ very, pleased, meet',
                '/ɪ/ visit, sister, sit, kitchen',
                '/eɪ/ making, cake, birthday ',
                '/ɛ/ next, step, recipe',
                '/æ/ family, travel, California',
                '/ɑ/ forgot, lock, car',
                '/ə/ apartment, beautiful, colorful',
                '/ɔ/ always, abroad, autumn',
                '/oʊ/ okay, show, photos',
                '/ʊ/ good, books',
                '/u/ June, too, humid',
                '/ər/ smarter, sister, harder',
                '/aɪ/ advise, ride, bicycle',
                '/aʊ/ found, couch lounge',
                '/ɔɪ/ enjoys, coins',
                '/f/ fault, leaf',
                '/v/ vault, leave',
                '/θ/ thank, breath',
                '/ð/ this, breathe',
                '/s/ sink, price',
                '/z/ zinc, prize',
                '/ʃ/ pressure, wish',
                '/ʒ/ pleasure, massage',
                '/tʃ/ choke, rich',
                '/ʤ/ joke, ridge',
                '/ŋ/ going, spring, king',
                '/l/ love, will, yellow',
                '/r/ red, four, card',
                '/w/ win, lower, quiet',
                '/y/ yes, mayor, young',
                '/h/ happy, behave, who'
            ],
            sentence:[
                'I’m very pleased to meet you.',
                'When I visit my sister, we sit in the kitchen.',
                'I’m making a cake for your birthday.',
                'What is the next step in the recipe?',
                'My family is travelling to California.',
                'I think I forgot to lock my car.',
                'Your apartment is so beautiful and colorful!',
                'I always go abroad in the autumn. ',
                'Is it okay if I show my brother your photos?',
                'Have you read any good books lately?',
                'The weather in June is too humid.',
                'I’m smarter than my sister, but she works harder.',
                'I advise you to ride a bicycle in China.',
                'I found him on the couch in the lounge.',
                'My uncle enjoys collecting old coins.',
                'Last night, Victoria fried some fresh fish.',
                'It’s better to give than receive.',
                'I think that the south has more warmth than the north.',
                'I’d rather have this one than that one.',
                'Salsa tastes so salty and sweet.',
                'Zoe visited the zebra in the zoo.',
                'I always wash my hair with shampoo and conditioner',
                'I usually don’t watch much television.',
                'You can choose a cheaper charger.',
                'She graduated from college with a degree in Asian languages.',
                'I like to drink something hot in the evening.',
                'I usually call people on my cellphone.',
                'The ring is on the wrong finger.',
                'I often take a quick walk between classes.',
                'Are you the youngest person in your class?',
                'My house is just behind that hill.'
            ],
            x: 'https://lex-audio.useremarkable.com/mp3/world_us_1.mp3',
            y:'https://lex-audio.useremarkable.com/mp3/beautiful_us_1.mp3',
            fileName:'',
            texttospeech1:false,
            texttospeech2:false,
            texttospeech3:false
        }
    },
    mounted(){
        let timestamp = new Date(this.$route.params.todate *1000)
        let m = this.get2Digit(timestamp.getMonth('m')+1)
        let d = this.get2Digit(timestamp.getDate())
        this.classDT = timestamp.getFullYear()+'-'+m+'-'+d
                        
           axios.get('https://phone.megatalking.com/origin/api/regularclass_evaluation.php?s_id='+this.$route.params.s_id+'&action=studentInfo')
        //.then(response=>console.warn(response.data))
        .then(response=>this.StudentData = response.data).catch(error=>console.log('this is the error Data '+error))
        
        if(this.submitStat == 'save'){
       

        axios.get('https://phone.megatalking.com/origin/api/regularclass_evaluation.php?s_id='+this.$route.params.s_id+'&todate='+this.$route.params.todate+'&action=classResult')
        // .then(response=>console.warn(response.data))
        .then((response)=>{ this.StudentInfo = response.data.contents
             this.word_audio1()
            this.word_audio2()
            this.word_audio3()
        }).catch(error=>console.log('this is the error Info '+error))

        axios.get('https://phone.megatalking.com/origin/api/regularclass_evaluation.php?s_id='+this.$route.params.s_id+'&todate='+this.$route.params.todate+'&action=classResult')
        // .then(response=>console.warn(response.data))
        .then((response)=> this.StudentRecordData = response.data).catch(error=>console.log('this is the error  RC '+error))

        // this.fetchingAPIKTT()
        }
        
        var audio=this.$refs.audioOne;
        audio.addEventListener(
          "loadedmetadata",
          function() {
            this.initSlider();
          }.bind(this)
        );

        audio.addEventListener(
          "canplay",
          function() {
            this.audioLoaded=true;
          }.bind(this)
        );

        this.$watch("isPlaying",function() {

          if(this.isPlaying) {
            var audio=this.$refs.audioOne;
            this.initSlider();
            if(!this.listenerActive) {
              this.listenerActive=true;

              audio.addEventListener("freqtimeupdate",this.playbackListener);
            }
          }

        });
        this.$watch("playbackTime",function() {
            // var audio=this.$refs.audioOne;

        var diff=Math.abs(this.playbackTime-this.$refs.audioOne.currentTime);

          if(diff>0.01) {
            this.$refs.audioOne.currentTime=this.playbackTime;

          }

        });

  


    },
    methods:{
        open(evalData){
          this.dialogshow = true
          this.evalData = evalData
           this.word_audio1()
          this.word_audio2()
          this.word_audio3()
          console.log(this.evalData)
        },
        async getDictionaryDef(vari,word){
          console.log(word)
                axios.get("https://ueducms.org/content-utilities/api/dictionary-proxy/"+word)
                    .then(rs => {
                      this[vari] = rs.data.item[0]
                        console.log(this.getdif1)
                            
                    }).catch(error=>console.log('this is the error '+error));
        },

        async getpapago(vari,word){
          // console.log(word)
            axios.get('https://phone.megatalking.com/origin/api/papago-api.php?word='+word)
        //.then(response=>console.warn(response.data))
        .then(response=>{
        this[vari] = response.data.message.result.translatedText
        // console.log(translatedtext)
        }).catch(error=>console.log('this is the error Data '+error))
        },
        //  async fetchingAPIKTT(){

        //     await this.StudentRecordingData

        //     axios.get('https://phone.megatalking.com/origin/api/regularclass_evaluation.php?s_id='+this.$route.params.s_id+'&todate='+this.$route.params.todate+'&action=classResult')
        //     // .then(response=>console.warn(response.data))
        //     .then((response)=> {this.StudentRecordingData=response.data,
            
        //         axios.get("https://phone.megatalking.com/origin/api/recordXML.php",
        //             {
        //             params:{
        //                 call_date: this.StudentRecordData.call_date,
        //                 phone_number: this.StudentRecordData.phone,
        //             }
        //             }
        //             )
        //             .then(rs => {
        //                 let parser = new DOMParser();
        //                     let xml = parser.parseFromString(rs.data,"application/xml");

        //                     this.fetchingXMLRecording(xml)
        //                     console.log(xml)
        //             });
                
            
            
        //     })


            

        //  },
         get2Digit(num){
                return ( num.toString().length < 2 ? "0"+num : num ).toString()
             },

        fetchingXMLRecording(xml){

                let dirname = xml.getElementsByTagName('dirname')
                let fname = xml.getElementsByTagName('fname')
                let call_time = xml.getElementsByTagName('call_time')

                let dir ='';
                let file ='';
                let ct = [];
                let ct_get = '';
                // console.warn(record)

                 for(let i =0 ; i<call_time.length ; i++){
                   ct.push(new Date('05-21-21 '+call_time[i].firstChild.nodeValue).getTime());
                }
               
                ct_get = Math.max.apply(null,ct)

                for(let i =0 ; i<dirname.length ; i++){
                   
                   if(new Date('05-21-21 '+call_time[i].firstChild.nodeValue).getTime() == ct_get){
                        dir = dirname[i].firstChild.nodeValue;
                        file = fname[i].firstChild.nodeValue; 
                        break;                    
                   }
                
                }
                // console.log(allFile)
                this.fileUrl ='http://121.78.147.57:8000'+dir+''+file
                  
            //    liveserver
                 axios.get("https://phone.megatalking.com/origin/api/testaudio.php?file="+this.fileUrl+"").then(rs =>{ this.fileName = rs.data[0]
              }).catch(error=>console.log('this is the error '+error));

            // local 
            //     axios.get("http://localhost/megatalking/testaudio.php?file="+this.fileUrl+"").then(rs =>{ this.fileName = rs.data[0]
            //   });

                // console.warn('http://121.78.147.57:8000/'+this.valueXMl+''+this.fileName)


        },
         getDefinition(word,variable,errorword,texttospeech){
          axios
            .get(
              "https://api.dictionaryapi.dev/api/v2/entries/en_US/" + word
            )
            .then(
              (response) =>{
                  
                  this[variable] =  response.data[0].meanings[0].definitions[0].definition
                  this[texttospeech] = true
                  
                
              }).catch(
              (error) =>
                error ? (this[errorword] = true) : (this[errorword] = false),
              (this.e1 = 1)
            );
    },


        async word_audio1(){
              await this.wordOneVal
              this.wordOneVal = this.evalData[0].wordOne
             axios.get('https://api.dictionaryapi.dev/api/v2/entries/en_US/'+this.wordOneVal).then(response =>{this.audioVal1=response.data[0].phonetics[0].audio
                if(!this.audioVal1){
                    this.audioVal1 = response.data[0].phonetics[1].audio
                    if(!this.audioVal1){
                    this.getDefinition(this.wordOneVal,"audioVal1","errorword1","texttospeech1") 
                    }
                  }
                  this.trans1= ""
                  this.getpapago("trans1",this.evalData[0].wordOne)
                  this.getDictionaryDef("getdif1",this.evalData[0].wordOne)
              }).catch(
              (error) =>
                error ? this.getDefinition(this.wordTwo,"audioVal2","errorword2","texttospeech2") : ''
            );
        },
         async word_audio2(){
             await this.wordTwoVal
              this.wordTwoVal = this.evalData[0].wordTwo

              axios.get('https://api.dictionaryapi.dev/api/v2/entries/en_US/'+this.wordTwoVal).then(response => {this.audioVal2=response.data[0].phonetics[0].audio
                
                if(!this.audioVal2){
                    this.audioVal2 = response.data[0].phonetics[1].audio
                    if(!this.audioVal2){
                    this.getDefinition(this.wordTwoVal,"audioVal2","errorword2","texttospeech2") 
                  }
                }
                this.trans2= ""
                this.getpapago("trans2",this.evalData[0].wordTwo)
                this.getDictionaryDef("getdif2",this.evalData[0].wordTwo)
              }).catch(
              (error) =>
                error ? this.getDefinition(this.wordTwo,"audioVal2","errorword2","texttospeech2") : ''
            );
        },
        async word_audio3(){
             await this.wordThreeVal
              this.wordThreeVal = this.evalData[0].wordThree

              axios.get('https://api.dictionaryapi.dev/api/v2/entries/en_US/'+this.wordThreeVal).then(response => {this.audioVal3=response.data[0].phonetics[0].audio

                   if(!this.audioVal3){
                      this.audioVal3 = response.data[0].phonetics[1].audio
                      if(!this.audioVal3){
                    this.getDefinition(this.wordThreeVal,"audioVal3","errorword3","texttospeech3") 
                  }
                  }
                  this.trans3= ""
                  this.getpapago("trans3",this.evalData[0].wordThree)
                  this.getDictionaryDef("getdif3",this.evalData[0].wordThree)
                  
              }).catch(
              (error) =>
                error ? this.getDefinition(this.wordTwo,"audioVal2","errorword2","texttospeech2") : ''
            );
        },


        MegaLevelName(val){
           
            if (val == 1 ) {
                return "Low Beginner"
            } else if (val == 2) {
                return "Beginner"
            } else if (val == 3) {
                return "High <br/> Beginner"
            } else if (val == 4) {
                return "Low <br /> Intermediate"
            } else if (val == 5 ) {
                return  "Intermediate"
            } else if (val == 6) {
                return  "High <br /> Intermediate"
            } else if (val == 7) {
                return "Pre <br /> Advanced"
            } else if (val == 8) {
                return  "Advanced"
            } else if (val == 9) {
                return "Post <br /> Advanced"
            } else {
                return " Undefined Level"
            }
        },
        ToeicLevel(val){
           
            if (val == 1) {
                return "2"
            } else if (val == 2) {
                return "3"
            } else if (val == 3) {
                return "4"
            } else if (val == 4) {
                return "5"
            } else if (val == 5 || val == 6) {
                return  "6"
            } else if (val == 7 || val == 8) {
                return "7"
            } else if (val == 9) {
                return  "8"
            } else {
                return " Undefined Level"
            }
        },
        OpicLevel(val){
           
            if (val ==1 ) {
                return "Novice Low"
            } else if (val == 2) {
                return "Novice Mid"
            } else if (val == 3) {
                return "Novice High"
            } else if (val == 4) {
                return "Intermediate Low"
            } else if (val == 5) {
                return  "Intermediate Mid 1"
            } else if (val == 6) {
                return  "Intermediate Mid 2"
            } else if (val == 7) {
                return "Intermediate Mid 3"
            } else if (val == 8) {
                return  "Intermediate High"
            } else if (val == 9) {
                return "Advanced Low"
            } else {
                return " Undefined Level"
            }
        },
        nextslide(val) {
            if (val == 1) {
                return this.prev = 2, this.next = 1

            } else if (val == 2) {

                    if (this.prev >= 3) {
                        return this.next = 2, this.prev = 3
                    } else if (this.prev <= 2) {
                        return this.next = 2, this.prev = 2
                    }

             } else if (val == 3) {

                    if (this.prev >= 4) {
                        return this.next = 3, this.prev = 4
                    } else if (this.prev <= 3) {
                        return this.next = 3, this.prev = 3
                    }

              } else if (val == 4) {
                
                    if (this.prev >= 5) {
                        return this.next = 4, this.prev = 5
                    } else if (this.prev <= 4) {
                        return this.next = 4, this.prev = 4
                    }

            } else if (val == 5) {
               

                    return this.next = 5, this.prev = 5

                } 
        },
        swipe(direction) {

            if (direction == 'Left') {
               if(this.next<5){
                   this.next++
                   this.prev++
                   console.warn(this.prev)
               }
            } else if (direction == 'Right') {
               if(this.next>1){
                   this.next--
                   this.prev--
                    console.warn(this.prev)
               }
            }
        },
         feedBack(){
        this.$router.push({name:'feedbackformStudentNew',params:{l_id:this.$route.params.l_id}})
      },
      enrollment(){
        window.location.href="https://megatalking.co.kr/enrollment"
      },

    }
}
</script>

